import React from "react";

const Loading = () => {
  return (
    <div className="text-center">
      <div
        className="spinner-border text-primary"
        style={{ width: "3rem", height: "3rem" }}
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default Loading;
